import { MbbRouter, MbbSubscriptionOffering } from '@sales/modules/mbb/models/mbb-offerings-response.model';
import { CustomerClassification } from '@shared/models/subscription-offering.model';
import { Selector } from '@ngxs/store';
import { OfferingMbbState, OfferingMbbStateModel } from './offering-mbb.state';

export class OfferingMbbSelectors {
  @Selector([OfferingMbbState])
  public static routers(state: OfferingMbbStateModel): MbbRouter[] {
    return state.routers;
  }

  @Selector([OfferingMbbState])
  public static isLoadingMbbProducts(state: OfferingMbbStateModel): boolean {
    return state.isLoadingMbbProducts;
  }

  @Selector([OfferingMbbState])
  public static isLoadingMbbRouters(state: OfferingMbbStateModel): boolean {
    return state.isLoadingMbbRouters;
  }

  @Selector([OfferingMbbState])
  public static getState(state: OfferingMbbStateModel): OfferingMbbStateModel {
    return state;
  }

  @Selector([OfferingMbbState])
  public static getAllMbbProductOfferings(state: OfferingMbbStateModel): MbbSubscriptionOffering[] {
    return state.products;
  }

  @Selector([OfferingMbbState])
  public static mbbProductOfferings(state: OfferingMbbStateModel): MbbSubscriptionOffering[] {
    return state.products.filter(p => p.customerClassification === CustomerClassification.B2C);
  }
}
